    <div class="modal-header">
        <h4 class="modal-title">Kunde Nr: {{kunde.glKundeNr}} </h4>
        <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">
        <div class="table__viewport">
            <table class="table table-hover table-striped table-sm table-frame__body" >
                <thead class="fixed-top position-fixed position-sticky">
                    <tr>
                        <th>Sag</th>
                        <th class="text-nowrap text-end">Regnskabsår</th>
                        <th class="text-nowrap text-end">Brugt</th>
                        <th class="text-nowrap text-end">Faktureret</th>
                        <th class="text-nowrap text-end">Dækning</th>
                    </tr>
                </thead>

                <tbody>
                <tr *ngFor="let sag of sager">
                    <td>{{ sag.sagsNavn }}</td>
                    <td class="text-end">{{ sag.regnskabsaar }}</td>
                    <td class="text-end link-td" (click)="OpenBrugtModal(sag)">{{ sag.brugt | currency:'DKK':'':'1.0-0':'da' }}</td>
                    <td class="text-end link-td" (click)="OpenFakturaModal(sag)">{{ sag.faktureret | currency:'DKK':'':'1.0-0':'da'  }}</td>
                    <td class="text-end">{{ (sag.faktureret - sag.brugt) | currency:'DKK':'':'1.0-0':'da'  }}</td>
                </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <th>Total</th>
                        <th></th>
                        <th class="text-end">{{brugtTotal() | currency:'DKK':'':'1.0-0':'da' }}</th>
                        <th class="text-end">{{faktureretTotal() | currency:'DKK':'':'1.0-0':'da' }}</th>
                        <th class="text-end">{{(faktureretTotal() - brugtTotal()) | currency:'DKK':'':'1.0-0':'da' }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
